import { transitionMotorInsuranceDocumentsForm } from '../../../actions/naMotorInsurance/Documents';
import { getDocumentsForm } from '../../../selectors/naMotorInsurance/documents';

import { FIELD_STATUS } from '../../../reducers/status';

export const documenetsFormRules = (store, next, action) => {
    const result = next(action);
    const documentsForm = getDocumentsForm(store.getState());
    const documentsFormValid = validateDocumentsFormDetails(documentsForm);
    const formAction = documentsFormValid
        ? transitionMotorInsuranceDocumentsForm.formValid()
        : transitionMotorInsuranceDocumentsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateDocumentsFormDetails = (formFields) => {
    return (
        formFields.idUpload &&
        formFields.idUpload.status === FIELD_STATUS.VALID &&
        formFields.licenseUpload &&
        formFields.licenseUpload.status === FIELD_STATUS.VALID
    );
};
